import { FuncaoForm } from '@presentation/components/organisms'
import { AddModal } from '@presentation/components/templates'
import { AddModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  onAdd: () => void
}

const AddFuncaoModal: React.FC<Props> = ({ onAdd }) => {
  const modalConfigs: AddModalProps = {
    path: '/funcoes',
    formId: 'add-funcao',
    nameForTitle: 'Função',
    validationSchema,
    onAdd
  }

  return (
    <AddModal {...modalConfigs}>
      <FuncaoForm />
    </AddModal>
  )
}

export default AddFuncaoModal
